<template>
  <svg :fill="iconColor" :width="iconSize" :height="iconSize" id="icon_like" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.65,11.14a1.46,1.46,0,0,0-1.46-1.46H12.26a.85.85,0,0,1-.85-.85V5.69a1.45,1.45,0,1,0-2.89,0V7.77a1.63,1.63,0,0,1-1,1.69,1.75,1.75,0,0,0-1.07,1.61.86.86,0,0,1-.86.85.25.25,0,0,0,0,.5A1.35,1.35,0,0,0,7,11.07,1.25,1.25,0,0,1,7.79,9.9,2.13,2.13,0,0,0,9,7.77V7.69h1.89V8.84a1.35,1.35,0,0,0,1.35,1.35h.24a1.44,1.44,0,0,0,.28,2.15,1.45,1.45,0,0,0,0,2.38,1.46,1.46,0,0,0,0,2.4,1.45,1.45,0,0,0-.63,1.19,1.47,1.47,0,0,0,.36,1H9.16c-1.84,0-2.26-.3-2.42-.88h0a1,1,0,0,0-1.15-.89.27.27,0,0,0-.23.27.25.25,0,0,0,.27.23.53.53,0,0,1,.62.51h0c.28,1,1.24,1.25,2.9,1.25h6.2a1.44,1.44,0,0,0,1.44-1.45,1.42,1.42,0,0,0-.37-1,1.45,1.45,0,0,0,.77-2.47,1.43,1.43,0,0,0,.51-2.38A1.46,1.46,0,0,0,18.65,11.14ZM9,6.19v-.5a.95.95,0,1,1,1.89,0v.5ZM13.6,19.26l-.09,0,.34-.48.36.5Zm.68-4.79.35-.5.36.5Zm.37.51-.37.52L13.9,15Zm.61,0h.22v1.88h-.22l-.67-.93Zm-.62,1.88h-.71l.35-.49Zm-1.05.51h.63l-.37.53-.37-.51Zm1.19.08v1.73l-.62-.86Zm.87-3h0l-.67-.93.66-.94h.05Zm-1.36-2.4.34-.49.35.49Zm.7.53-.36.51-.37-.51Zm.61-.53-.66-.92.66-.94h.19v1.86Zm-1-1.35-.37-.51H15Zm-1-.51h0l.68.94-.64.92H13.6a.93.93,0,0,1,0-1.86Zm-.94,3.32a.93.93,0,0,1,.91-.93h.07l.68,1-.65.92H13.6A.94.94,0,0,1,12.66,13.53ZM13.32,15l.66.9-.62.87a.92.92,0,0,1,0-1.77ZM13,17.59l.53.74-.5.72a.92.92,0,0,1-.38-.74A1,1,0,0,1,13,17.59Zm2.52,1.63V17.4a.92.92,0,0,1,0,1.82Zm.7-2.37V15a.93.93,0,0,1,0,1.86Zm.47-2.38h-.3V12.6h.35a.94.94,0,0,1-.05,1.87Zm.49-2.4h-.65V10.21h.65a.93.93,0,0,1,0,1.86Z"/></svg>
</template>
<script>
export default {
  data() {
    return {
      iconColor: "white",
      iconSize: "32px"
    };
  },
  mounted(){
    if(this.color)
      this.iconColor = this.getColor(this.color);
    if(this.size)
      this.iconSize = this.size;
  },
  props: ['color','size'],
  watch: {
    color: {
      handler: function(newValue) {
        if(newValue)
          this.iconColor = this.getColor(newValue);
      }
    }
  }
};
</script>
<style>
  svg {
    display: inline-block;
    vertical-align: baseline;
    margin-bottom: -6px; 
  }
</style>